import { render } from "./Professionals.vue?vue&type=template&id=54d2ec86"
import script from "./Professionals.vue?vue&type=script&lang=js"
export * from "./Professionals.vue?vue&type=script&lang=js"

import "./Professionals.vue?vue&type=style&index=0&id=54d2ec86&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__